module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"egidTitle":"EGID","gebnrTitle":"Amtl. Gebäudenr.","buildingYearTitle":"Baujahr","floorsTitle":"Anzahl Geschosse","areaTitle":"Gebäudefläche","buildingCategoryTitle":"Gebäudekategorie","buildingClassTitle":"Gebäudeklasse","flatsTitle":"Anzahl Wohnungen"}}')
  delete Component.options._Ctor
}
